import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { selectPage } from 'redux/modules/flag';

export function useSelectPageId({ sectionListData, isResult }) {
    const dispatch = useDispatch();
    useEffect(() => {
        if (sectionListData) {
            if (isResult) {
                const { pageId } = sectionListData.find(page => page.pageType === 2);
                dispatch(selectPage(pageId));
            } else {
                const { pageId } = sectionListData.find(page => page.pageType === 1);
                dispatch(selectPage(pageId));
            }
        }
    }, [isResult, dispatch, sectionListData]);
}
